import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { AlertController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorService {
   errMsg: string;
   msgHeader: string;

  constructor(public alertController: AlertController) { }

  public handleError(error: HttpErrorResponse | any){
    console.log(error);
    if(error.error instanceof ErrorEvent){
      this.errMsg = error.error.message;
      this.msgHeader = `Error Status : ${error.error.status}`;
    }
    else{
      if(error.status === 0){
      this.errMsg = 'Something unxpected happend, check your INTERNET CONNECTION and try again.';
      }
      else if(error.status === 500){
      this.errMsg = 'We are finding some difficult in processing your request. Try again a bit later.';
      }
      else if(error.status === 401){
        this.errMsg = 'PASSWORD and or USER NAME doesnt match.';
        }
      else{
      this.errMsg = `${error.status} - ${error.statusText || ''} ${error.message}`;
      }
      if (error.error && error.error.message) {
        this.errMsg = error.error.message;
      }
      this.msgHeader = `Sorry, error encountered! `;
    }
// shows error in an alert(dialgue)
     this.errorAlert();
     return throwError( this.errMsg);
  }

// Alert for displaying error messages.
  async errorAlert() {
    const alert = await this.alertController.create({
      cssClass: 'error-dialog',
      header: this.msgHeader,
      message:  this.errMsg,
      translucent: true,
      animated: true,
      buttons: ['OK']
    });
    await alert.present();
  }
}
